export const commonTooltipOptions = {
    backgroundColor: 'rgba(15, 23, 42, 0.95)',
    titleColor: '#F1F5F9',
    bodyColor: '#CBD5E1',
    borderColor: 'rgba(51, 65, 85, 0.9)',
    borderWidth: 1,
    padding: 10,
};

export const commonLegendOptions = {
    labels: {
        color: '#E2E8F0',
        font: { size: 12 },
        boxWidth: 15,
        padding: 20,
    }
};

export const baseScalesOptions = {
    x: {
        grid: { color: 'rgba(255, 255, 255, 0.05)' },
        ticks: { color: '#94A3B8', font: { size: 12 } },
    },
    y: {
        grid: { color: 'rgba(255, 255, 255, 0.05)' },
        ticks: { color: '#94A3B8', font: { size: 12 } },
        beginAtZero: true,
    },
};

export const chartColors = {
    primary: 'rgba(59, 130, 246, 1)',
    primaryLight: 'rgba(59, 130, 246, 0.85)',
    primaryArea: 'rgba(59, 130, 246, 0.15)',
    secondary: 'rgba(130, 144, 166, 1)',
    secondaryLight: 'rgba(130, 144, 166, 0.9)',
};
